export default function CoinbaseLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        fill="#0052FF"
        d="M16.03 24c-4.428 0-8.015-3.58-8.015-8s3.587-8 8.015-8a8.008 8.008 0 0 1 7.895 6.667H32C31.319 6.453 24.433 0 16.03 0 7.18 0 0 7.167 0 16s7.18 16 16.03 16C24.432 32 31.32 25.547 32 17.333h-8.075A8.008 8.008 0 0 1 16.03 24Z"
      />
    </svg>
  );
}
